import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useRemoteDomains from "../../../../hooks/queryResults/remote/useRemoteDomains";
import Util from "../../../../util/util";
import Table from "../../../layout/Table";
import Loading from "../../../ui/Loading";

export default function AdminRemoteDomainsTable() {
  const { domains, remoteDomainsQuery } = useRemoteDomains();

  const domainColumns = useMemo(
    () =>
      Util.makeTableColumns([
        "id",
        { value: "name", className: "left" },
        "slug",
        "templates",
        "status",
        "progress",
      ]),
    []
  );

  const domainData = useMemo(() => {
    const makeData = (domains) => {
      const data = [];

      if (domains) {
        const domainsArray = Object.keys(domains)
          .map((id) => domains[id])
          .sort((a, b) => {
            if (a.name === b.name) return 0;
            return a.name < b.name ? -1 : 1;
          });

        domainsArray.forEach((domain) => {
          data.push({
            id: <Link to={`/admin/remote/${domain?.slug}`}>{domain.id}</Link>,
            name: (
              <Link to={`/admin/remote/${domain?.slug}`}>{domain.name}</Link>
            ),
            slug: (
              <Link to={`/admin/remote/${domain?.slug}`}>{domain.slug}</Link>
            ),
            templates: domain.numTemplates,
            status: domain.status,
            progress: (
              <Link
                style={{ textDecoration: "none" }}
                to={`/admin/remote/${domain?.slug}`}
              >
                {Util.getProgressIcon(domain.progress)}
              </Link>
            ),
          });
        });
      }

      return data;
    };

    return makeData(domains);
  }, [domains]);

  if (remoteDomainsQuery.isLoading) return <Loading />;

  if (domains) {
    return <Table columns={domainColumns} data={domainData} />;
  }

  return null;
}
